// @flow
import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Row,
  Col,
  Popover,
  PopoverHeader,
  PopoverBody
} from "reactstrap";
import "./../../node_modules/react-select/dist/react-select.css";
import Select, { Creatable } from "react-select";
import { bindActionCreators } from "redux";
import * as actions from "../actions";
import { compose, checkForm, setIn } from "../common/utils";
import * as API from "../common/api";
import styled from "../common/styled";
import { s3Delete } from "../common/aws_lib";

const { Text, Image, View } = styled.plain;

const checks = [
  {
    related: ["ctaText"],
    check: s => s && s.length,
    errMsg: () => "CTA Text Required"
  }
];

const checkFormData = checkForm(checks);

class SettingsForm extends React.Component {
  state = {
    errMsg: null,
    isSubmitting: false,
    formData: {
      ctaText: ""
    }
  };

  componentDidMount() {
    this.props.loadSettings();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.settings && nextProps.settings !== this.props.settings) {
      this.setState({ formData: nextProps.settings });
    }
  }

  onChangeField = (key, val) => {
    this.setState(setIn(["formData", key], val, this.state));
  };

  validateForm = fields => {
    const data = this.state.formData;
    const errMsgs = checkFormData(data, fields);
    const newErrMsgs =
      fields && fields.length > 0
        ? { ...this.state.errMsgs, ...errMsgs }
        : errMsgs;
    const hasError =
      Object.keys(newErrMsgs).filter(key => newErrMsgs[key]).length > 0;

    if (!fields && hasError) {
      const firstError = Object.keys(errMsgs)
        .map(key => errMsgs[key])
        .filter(x => !!x)[0];
      toast.error(firstError);
    }

    this.setState({ errMsgs: newErrMsgs });
    return !hasError;
  };

  onSubmit = () => {
    if (!this.validateForm()) return;

    const data = this.state.formData;

    return actions.wrapLoading(
      this.props,
      API.UpdateSettings(data.ctaText).then(
        result => {
          toast.success("Successfully Saved");
          return this.props.onDone();
        },
        e => {
          const msg = e.message;
          toast.error(msg);
        }
      )
    );
  };

  render() {
    return (
      <Modal
        isOpen={this.props.visible}
        className="photoModal"
        onClosed={this.props.onClose}
        size="lg"
      >
        <ModalHeader>Manage Settings</ModalHeader>
        <ModalBody>
          <Form className="photo-form">
            <div className="form-field">
              <Row>
                <Col md="12">
                  <FormGroup>
                    <Label>CTA Text</Label>
                    <Input
                      type="text"
                      name="ctaText"
                      required
                      value={this.state.formData.ctaText}
                      onChange={e =>
                        this.onChangeField("ctaText", e.target.value)
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={this.props.onClose}>
            Cancel
          </Button>
          <Button color="primary" outline onClick={() => this.onSubmit()}>
            Save
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

SettingsForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired
};

export default compose(
  connect(
    state => ({
      settings: state.settings.detail
    }),
    dispatch => bindActionCreators({ ...actions }, dispatch)
  ),
  withRouter
)(SettingsForm);
